import type { ProgressReport, ProgressReportPeriod } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ProgressReportStore } from '@stores/progress-report/interfaces'

import { getReport } from '@utils/stores/progress-report/getters/report'

export const getPeriodLabel = (report: Pick<ProgressReport, 'period'> | null): string => {
  const period = report?.period

  if (!period) return ''

  return `${period.from} – ${period.to}`
}

export const period = {
  getPeriod: (state: ProgressReportStore): ProgressReportPeriod | null => getReport(state)?.period || null,
  getPeriodLabel: (state: ProgressReportStore): string => getPeriodLabel(getReport(state)),
}
